<script lang="ts">
import { defineComponent, PropType } from "vue";
import TitelZelle from "@/components/grid/TitelZelle.vue";
import Zelle from "@/components/grid/Zelle.vue";
import Zeile from "@/components/grid/Zeile.vue";
import ValidierungsFehler from "@/components/ValidierungsFehler.vue";
import { Gebaeudetypen } from "@/components/gebaeudetypen/model/Gebaeudetypen";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "GebaeudeTypRadio",
  components: {
    TitelZelle,
    Zelle,
    Zeile,
    ValidierungsFehler,
  },
  props: {
    gebaeudetypen: Object as PropType<Gebaeudetypen[]>,
    required: Boolean,
    fehler: {
      type: Object,
    },
  },
  setup() {
    const piniaStore = useFormStore();
    return {
      piniaStore,
    };
  },
});
</script>

<template>
  <zeile>
    <titel-zelle>Gebäudetyp</titel-zelle>
    <zelle class="mkRadio">
      <template v-for="(option, index) in gebaeudetypen" :key="index">
        <input
          type="radio"
          :id="option.label"
          name="gebaeudetyp"
          v-model="piniaStore.state.gebaeudedaten.gebaeudetyp"
          :checked="option.value === piniaStore.state.gebaeudedaten.gebaeudetyp"
          :value="option.value"
          :required="required"
          :aria-required="required"
          autofocus
        />
        <label :for="option.label" class="radiolabel">
          {{ option.label }}
        </label>
      </template>
      <validierungs-fehler :fehler-text="fehler.gebaeudetyp" :reduzierter-abstand="true" />
    </zelle>
  </zeile>
</template>
